module.exports = __webpack_public_path__ + "media/stylesheets/images/sareye_old-441d1075682905693a5ee6c40b21f9c3.svg";